import BaseService from "@/services/BaseService";
import * as URI from "../nerp/constant";

const action = {
  async getCampaignMasterAction({ commit }, payload) {
    let url = URI.CAMPAIGN_MASTER_LIST_URL.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const campaignMaster = await BaseService.getSchemePlanningClient().get(url);
    commit("setCampaignMaster", campaignMaster.data);
    return campaignMaster.data;
  },
  async deleteCampaignMasterModal({ commit }, payload) {
    const url = URI.DELETE_CAMPAIGN_MASTER_URL.replace("{campaignManagementId}", payload.id);
    const response = await BaseService.getSchemePlanningClient().delete(url);
    return response.data;
  },
  async saveCampaignMasterDataAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.SAVE_CAMPAIGN_MASTER_URL,
      payload
    );
    return response.data;
  },
  async downloadCampaignMasterExport({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.EXPORT_CAMPAIGN_MASTER_URL,
      payload,
      {
        responseType: "blob",
      }
    );
    return response;
  },
  async getCustomerMasterAction({ commit }, payload) {
    let url = URI.CUSTOMER_MASTER_LIST_URL.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const customerMaster = await BaseService.getSchemePlanningClient().get(url);
    commit("setCustomerMaster", customerMaster.data);
    return customerMaster.data;
  },
  async deleteCustomerMasterModal({ commit }, payload) {
    const url = URI.DELETE_CUSTOMER_MASTER_URL.replace("{customerMasterId}", payload.id);
    const response = await BaseService.getSchemePlanningClient().delete(url);
    return response.data;
  },
  async saveCustomerMasterDataAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.SAVE_CUSTOMER_MASTER_URL,
      payload
    );
    return response.data;
  },
  async downloadCustomerMasterTemplate({ commit }, payload) {
    let url = URI.DOWNLOAD_TEMPLATE_CUSTOMER_MASTER_URL
    let response = {};
    try {
      response = await BaseService.getSchemePlanningClient().get(url, {
        responseType: "blob",
      });
    } catch (error) {
      // response = await BaseService.getSchemePlanningClient().get(url);
    }
    return response;
  },
  async getSoldToCodeListAction({commit},payload){
    let url = URI.SMART_SEARCH_SOLD_TO_CODE.replace(
      "{searchKey}",
      payload.searchKey
    )
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setSoldToCodeLists", response.data);
    return response;
  },
  async importCustomeMasterUpdateAction({ commit }, payload) {
    const url = URI.IMPORT_CUSTOMER_MASTER_URL;
    const response = await BaseService.getSchemePlanningClient().put(
      url,
      payload.form,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response;
  },
  async importCustomeMasterCreateAction({ commit }, payload) {
    const url = URI.IMPORT_CUSTOMER_MASTER_URL;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.form,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response;
  },
  async downloadCustomerMasterExport({ commit }, payload) {
    let url = URI.DOWNLOAD_EXPORT_CUSTOMER_MASTER_URL
    let response = {};
    try {
      response = await BaseService.getSchemePlanningClient().get(url, {
        responseType: "blob",
      });
    } catch (error) {
      // response = await BaseService.getSchemePlanningClient().get(url);
    }
    return response;
  },
  async getPurposeTypeAction({ commit },payload) {
    const purposeType = await BaseService.getSchemePlanningClient().get(URI.PURPOSE_TYPE_URL);
    commit("setPurposeType", purposeType.data);
    return purposeType.data; 
  },
  async nerpCappingManegementMaster({ commit }, payload) {
    let url = URI.NERP_CAMPING_MASTER;
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setNerpCampaignMaster", response.data.data);
    return response.data;
  },
  async setProductTypeCampaign({ commit }, payload) {
    commit("setProductTypeCampaign", payload);
  },
};

export default action;
